// @flow
import styled from "styled-components"
import { TweenMax, Cubic } from "gsap"
import * as React from "react"

const BackgroundContainer = styled.div`
  display: ${({ flex }) => (flex ? "flex" : "block")};
  flex-direction: column;
  background: url(${props => props.imgSrc}) no-repeat center center;
  background-size: cover;
  height: 100%;
  width: 100%;
  position: relative;
`

const ChildrenContainer = BackgroundContainer.extend`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  background: transparent;
`

const AbsoluteBackgroundContainer = BackgroundContainer.extend`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`

type Props = {
  innerRef?: (el: HTMLElement) => any,
  imgSrc: string,
  zoom?: boolean,
  flex?: boolean,
  children: React.ChildrenArray<React.Element<any>>,
  onClick: (e: Event) => any
}

const ZOOM_FACTOR = 1.2

class ZoomableBackgroundContainer extends React.Component<Props> {
  background: ?HTMLElement

  constructor(props: Props) {
    super(props)
    this.background = null
  }

  componentDidMount() {
    const { zoom } = this.props
    if (zoom) {
      TweenMax.set(this.background, {
        scale: ZOOM_FACTOR
      })
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.zoom !== this.props.zoom) {
      TweenMax.to(this.background, 0.5, {
        ease: Cubic.easeInOut,
        scale: this.props.zoom ? ZOOM_FACTOR : 1
      })
    }
  }

  render() {
    const { innerRef, imgSrc, flex, children, onClick } = this.props

    return (
      <BackgroundContainer innerRef={innerRef} onClick={onClick}>
        <ChildrenContainer>{children}</ChildrenContainer>
        <AbsoluteBackgroundContainer
          imgSrc={imgSrc}
          flex={flex}
          innerRef={el => (this.background = el)}
        />
      </BackgroundContainer>
    )
  }
}

export { ZoomableBackgroundContainer }

export default BackgroundContainer



// WEBPACK FOOTER //
// ./src/UI/BackgroundContainer/index.js